import { observer } from 'mobx-react-lite';
import * as React from 'react';

import ProfileModel from 'src/models/account/ProfileModel';
import ResetPasswordModel from 'src/models/account/ResetPasswordModel';
import InputDefinitionBuilder from '../../../../utils/inputDefinitions/InputDefinitionBuilder';
import StandardTextBoxField from '../../textbox/StandardTextBoxField';
import { IInputFieldProps } from '../common/IInputFieldProps';

interface IUserConfirmPasswordField extends IInputFieldProps {
  model: ProfileModel | ResetPasswordModel;
}

const UserConfirmPasswordField: React.FC<IUserConfirmPasswordField> = (props: IUserConfirmPasswordField) => {
  const [inputDefinition] = React.useState(() => {
    return new InputDefinitionBuilder('Confirm Password')
      .WithRequiredTextBoxField()
      .WithPlaceholder('Confirm Password')
      .WithCustomValidationRule(() => {
        if (props.model.confirmPassword !== props.model.password) {
          return 'Passwords do not match';
        }
      })
      .Build();
  });
  return (
    <StandardTextBoxField
      name='confirmPassword'
      value={props.model.confirmPassword}
      onModelChange={props.model.OnModelChange}
      inputDefinition={inputDefinition}
      type='password'
      disableOnBlurValidation={false}
      noStyle={props.noStyle}
    />
  );
};

export default observer(UserConfirmPasswordField);
